import { gql } from "@apollo/client";

const EDIT_NOMINATION = gql`
mutation EditOutgoingNomination($editOutgoingNominationId: String!, $nominationData: EditNominationInput!) {
  editOutgoingNomination(id: $editOutgoingNominationId, nominationData: $nominationData) {
    id
    field_student_first_name
    field_student_last_name
    field_student_esi
    field_student_birth_date
    field_student_nationality
    field_student_gender
    field_student_email
    field_academic_term
    field_academic_year
    field_student_isced
    field_student_eqf
    field_open_comment
    field_mobility_details {
      id
      field_home_org_unit
      field_host_org_unit
      field_home_iia_id
      field_host_iia_id
      field_home_erasmus_code
      field_host_erasmus_code
      field_home_name
      field_host_name
    }
  }
}
`;

export default EDIT_NOMINATION;
